import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormOctagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"form-octagon"} maskId="square-filled-radius-0-stroke-1-IconFormOctagon"><path d="M22 7.85742V16.1426L16.1426 22H7.85742L2 16.1426V7.85742L7.85742 2H16.1426L22 7.85742Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFormOctagon;
